import { useState } from "react";
import { Megaphone } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PROVENIENZE } from "@/lib/format";
import { Btn } from "@/components/rp";

export const ProvenienzaCard = ({ c, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [f, setF] = useState({ provenienza: c.provenienza || "", provenienza_note: c.provenienza_note || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.patch(`/admin/clients/${c.id}/provenienza`, f); onSaved(data); setEdit(false); toast.success("Provenienza salvata"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="rp-card p-5 sm:p-6 flex flex-wrap items-center gap-4" data-testid="client-provenienza-card">
      <span className="h-10 w-10 rounded-full bg-[#E6DDCE] flex items-center justify-center shrink-0"><Megaphone className="h-4 w-4" /></span>
      {!edit ? (
        <>
          <div className="flex-1 min-w-[180px]">
            <p className="rp-label">Provenienza</p>
            <p className="font-medium" data-testid="client-provenienza-value">{c.provenienza || "Non indicata"}</p>
            {c.provenienza_note && <p className="text-sm text-[#757575]" data-testid="client-provenienza-note">{c.provenienza_note}</p>}
          </div>
          <Btn variant="outline" onClick={() => setEdit(true)} data-testid="client-provenienza-edit">Modifica</Btn>
        </>
      ) : (
        <div className="flex-1 grid sm:grid-cols-[220px_1fr_auto] gap-3 items-center">
          <select value={f.provenienza} onChange={(e) => setF({ ...f, provenienza: e.target.value })} className="rp-field" data-testid="client-provenienza-select">
            <option value="">Non indicata</option>
            {PROVENIENZE.map((p) => <option key={p} value={p}>{p}</option>)}
          </select>
          <input value={f.provenienza_note} onChange={(e) => setF({ ...f, provenienza_note: e.target.value })} className="rp-field" placeholder="Dettaglio (es. consigliato da Mario Rossi)" data-testid="client-provenienza-note-input" />
          <div className="flex gap-2">
            <Btn variant="secondary" onClick={() => setEdit(false)} data-testid="client-provenienza-cancel">Annulla</Btn>
            <Btn loading={busy} onClick={save} data-testid="client-provenienza-save">Salva</Btn>
          </div>
        </div>
      )}
    </div>
  );
};
